import { render, staticRenderFns } from "./ValorKmList.vue?vue&type=template&id=1f4fea48&scoped=true"
import script from "./ValorKmList.vue?vue&type=script&lang=js"
export * from "./ValorKmList.vue?vue&type=script&lang=js"
import style0 from "./ValorKmList.vue?vue&type=style&index=0&id=1f4fea48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4fea48",
  null
  
)

export default component.exports